<ng-container *ngIf="isLobby; else gameTable">
  <lobby>
  </lobby>
</ng-container>
<ng-template #gameTable>
  <game-room>
  </game-room>
</ng-template>
